import { Classes } from '@blueprintjs/core';
import { ace_hooks } from '@axo/shared/data-access/hooks';

interface Props {
  id: string;
}

export function ConditionSummary({ id }: Props) {
  const bucket = ace_hooks.useBucket(id);

  if (bucket.isLoading) {
    return <span className={Classes.SKELETON}>%bucket condition summary%</span>;
  }

  if (!bucket.data?.ConditionsExplanation) {
    return <em className={Classes.TEXT_MUTED}>No summary available</em>;
  }

  return <>{bucket.data.ConditionsExplanation}</>;
}
